import React from 'react';
import classNames from 'classnames';

import FilterComponent from '../FilterComponent';
import css from './SearchFiltersPanel.module.css';

// Each subcategory's `params` object contains the exact URL params to submit.
// Chips at level 2 only need level1+level2. Level 3 chips need level1+level2+level3.
// IDs match the hosted Sharetribe category asset exactly.
const SECTIONS = [
  {
    label: 'Boats',
    listingType: 'boat-rental',
    subcategories: [
      { name: 'Power Boats',    params: { pub_categoryLevel1: 'BoatRentals', pub_categoryLevel2: 'power-boats' } },
      { name: 'Sailboats',      params: { pub_categoryLevel1: 'BoatRentals', pub_categoryLevel2: 'sailboats' } },
      { name: 'Wakesurf Boats', params: { pub_categoryLevel1: 'BoatRentals', pub_categoryLevel2: 'power-boats', pub_categoryLevel3: 'wakesurf-boats' } },
      { name: 'Pontoon Boats',  params: { pub_categoryLevel1: 'BoatRentals', pub_categoryLevel2: 'power-boats', pub_categoryLevel3: 'pontoon-tritoon' } },
      { name: 'Fishing Boats',  params: { pub_categoryLevel1: 'BoatRentals', pub_categoryLevel2: 'power-boats', pub_categoryLevel3: 'fishing-boats' } },
      { name: 'Center Console', params: { pub_categoryLevel1: 'BoatRentals', pub_categoryLevel2: 'power-boats', pub_categoryLevel3: 'center-console' } },
      { name: 'Cabin Cruiser',  params: { pub_categoryLevel1: 'BoatRentals', pub_categoryLevel2: 'power-boats', pub_categoryLevel3: 'cabin-cruiser' } },
    ],
  },
  {
    label: 'Captains',
    listingType: 'captains-crew-transport',
    subcategories: [
      { name: 'Licensed Captains', params: { pub_categoryLevel1: 'captains', pub_categoryLevel2: 'licensed-captains' } },
      { name: 'Boat Drivers',      params: { pub_categoryLevel1: 'captains', pub_categoryLevel2: 'boat-drivers-unlicensed' } },
      { name: 'Guides',            params: { pub_categoryLevel1: 'captains', pub_categoryLevel2: 'guides' } },
    ],
  },
  {
    label: 'Delivery & Logistics',
    listingType: 'dock-ramp-delivery',
    subcategories: [
      { name: 'Dock Delivery',  params: { pub_categoryLevel1: 'dock-ramp-delivery', pub_categoryLevel2: 'dockdelivery' } },
      { name: 'Boat Ramp',      params: { pub_categoryLevel1: 'dock-ramp-delivery', pub_categoryLevel2: 'ramplaunch' } },
      { name: 'Full-Service',   params: { pub_categoryLevel1: 'dock-ramp-delivery', pub_categoryLevel2: 'full-service-delivery' } },
    ],
  },
  {
    label: 'Storage',
    listingType: 'buoys-moorage-storage',
    subcategories: [
      { name: 'Moorage',               params: { pub_categoryLevel1: 'moorage-storage-parking', pub_categoryLevel2: 'on-water-moorage' } },
      { name: 'Buoys',                 params: { pub_categoryLevel1: 'moorage-storage-parking', pub_categoryLevel2: 'on-water-moorage', pub_categoryLevel3: 'mooring-buoy-for-rent' } },
      { name: 'Slips',                 params: { pub_categoryLevel1: 'moorage-storage-parking', pub_categoryLevel2: 'on-water-moorage', pub_categoryLevel3: 'slip' } },
      { name: 'Docks',                 params: { pub_categoryLevel1: 'moorage-storage-parking', pub_categoryLevel2: 'on-water-moorage', pub_categoryLevel3: 'dock' } },
      { name: 'Land Storage',          params: { pub_categoryLevel1: 'moorage-storage-parking', pub_categoryLevel2: 'land-storage' } },
      { name: 'Boat & Trailer Parking',params: { pub_categoryLevel1: 'moorage-storage-parking', pub_categoryLevel2: 'land-storage', pub_categoryLevel3: 'boat-trailer-parking' } },
      { name: 'Off-Season Storage',    params: { pub_categoryLevel1: 'moorage-storage-parking', pub_categoryLevel2: 'land-storage', pub_categoryLevel3: 'off-season-storage' } },
    ],
  },
  {
    label: 'Services',
    listingType: 'marine-services',
    subcategories: [
      { name: 'Mechanics',           params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'mechanics' } },
      { name: 'Detailers',           params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'detailers' } },
      { name: 'Fiberglass',          params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'fiberglass-gelcoat' } },
      { name: 'Emergency Towing',    params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'emergency-on-water-towing' } },
      { name: 'Bottom Cleaning',     params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'bottom-cleaning' } },
      { name: 'Winterization',       params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'winterization-and-shrink-wrap' } },
      { name: 'Electronics',         params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'electronics-installation' } },
      { name: 'Canvas & Upholstery', params: { pub_categoryLevel1: 'mechanics-and-technicians', pub_categoryLevel2: 'canvas-and-upholstery-repair' } },
    ],
  },
  {
    label: 'Paddle & Gear',
    listingType: 'accessory-rental',
    subcategories: [
      { name: 'Canoes',                   params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'canoes' } },
      { name: 'Fishing Gear',             params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'fishing-gear' } },
      { name: 'Floating Islands',         params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'floatingislands' } },
      { name: 'Foil Boards',              params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'foilboards-non-motorized' } },
      { name: 'Kayaks',                   params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'kayaks' } },
      { name: 'Kneeboards',               params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'kneeboards' } },
      { name: 'Pedal Boats',              params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'pedal-boats' } },
      { name: 'River Rafts',              params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'river-rafts' } },
      { name: 'Row Boats',                params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'row-boats' } },
      { name: 'Specialty / Niche',        params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'specialty-niche' } },
      { name: 'Specialty Towables',       params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'specialtytowables' } },
      { name: 'Stand-Up Paddle Boards',   params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'paddle-boards' } },
      { name: 'Tubes',                    params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'tubes' } },
      { name: 'Wakeboards',               params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'wakeboards' } },
      { name: 'Wakesurf Boards',          params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'wakesurfboards' } },
      { name: 'Waterskis',                params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'waterskis' } },
      { name: 'Wetsuits',                 params: { pub_categoryLevel1: 'accessories-boating', pub_categoryLevel2: 'wetsuits' } },
    ],
  },
];

const parseHasAny = raw => {
  if (!raw) return [];
  const s = raw.toString();
  return s.startsWith('has_any:')
    ? s.slice('has_any:'.length).split(',').map(v => v.trim()).filter(Boolean)
    : [s];
};

const toHasAny = arr => (arr.length > 0 ? `has_any:${arr.join(',')}` : null);

/**
 * SearchFiltersPanel — centered modal overlay.
 * Sections: Dates, Price (via FilterComponent), per-type category chips, Sort By.
 */
const SearchFiltersPanel = ({
  isOpen,
  onClose,
  validQueryParams,
  onSubmit,
  listingCategories,
  totalItems,
  searchInProgress,
  // Date / price / seats filter configs from SearchFilterBar
  datesConfig,
  priceConfig,
  seatsConfig,
  marketplaceCurrency,
  initialValuesFn,
  getHandleChangedValueFn,
  intl,
  // Sort
  isSortActive,
  sortOptions,
  sortQueryParamName,
  currentSort,
  onSortSelect,
}) => {
  const selectedTypes = parseHasAny(validQueryParams?.pub_listingType);

  const toggleType = lt => {
    const next = selectedTypes.includes(lt)
      ? selectedTypes.filter(v => v !== lt)
      : [...selectedTypes, lt];
    onSubmit({ pub_listingType: toHasAny(next) });
  };

  // A chip is active when every param in sub.params matches the current URL.
  const isChipActive = sub =>
    Object.entries(sub.params).every(([k, v]) => validQueryParams?.[k] === v);

  // Click toggles: if already active, clear all category levels; otherwise apply chip's params.
  const handleChipClick = sub => {
    if (isChipActive(sub)) {
      onSubmit({ pub_categoryLevel1: null, pub_categoryLevel2: null, pub_categoryLevel3: null });
    } else {
      onSubmit({
        pub_categoryLevel1: null,
        pub_categoryLevel2: null,
        pub_categoryLevel3: null,
        ...sub.params,
      });
    }
  };

  if (!isOpen) return null;

  const resultsLabel = searchInProgress
    ? 'Loading…'
    : `Show ${totalItems ?? 0} result${totalItems !== 1 ? 's' : ''}`;

  const handleClearAll = () => {
    onSubmit({
      pub_categoryLevel1: null,
      pub_categoryLevel2: null,
      pub_categoryLevel3: null,
      pub_listingType: null,
      dates: null,
      price: null,
      seats: null,
      pub_hired_captain_crew_requirements: null,
      pub_pickup_options: null,
    });
    onClose();
  };

  // Shared props for FilterComponent children inside the panel.
  const filterComponentProps = {
    containerId: 'SearchFiltersPanel',
    listingCategories,
    marketplaceCurrency,
    urlQueryParams: validQueryParams,
    initialValues: initialValuesFn,
    getHandleChangedValueFn,
    intl,
    showAsPopup: false,
    liveEdit: true,
    initialIsOpen: false,
  };

  return (
    <>
      {/* Dark backdrop */}
      <div className={css.backdrop} onClick={onClose} />

      {/* Modal */}
      <div className={css.panel} role="dialog" aria-modal="true" aria-label="Filters">
        {/* Drag handle — mobile only */}
        <div className={css.mobileHandle} />

        {/* Mobile header: Reset | Filters | Done */}
        <div className={css.mobileHeader}>
          <button
            type="button"
            className={css.mobileResetBtn}
            onClick={handleClearAll}
          >
            Reset
          </button>
          <span className={css.headerTitle}>Filters</span>
          <button
            type="button"
            className={css.mobileDoneBtn}
            onClick={onClose}
          >
            Done
          </button>
        </div>

        {/* Desktop header: X close button — hidden on mobile */}
        <div className={css.header}>
          <span className={css.headerTitle}>Filters</span>
          <button
            type="button"
            className={css.closeBtn}
            onClick={onClose}
            aria-label="Close filters"
          >
            ✕
          </button>
        </div>

        {/* Scrollable content */}
        <div className={css.content}>

          {/* Price section — always expanded, FilterPlain header hidden via CSS */}
          {priceConfig && (
            <div className={classNames(css.section, css.priceSection)}>
              <div className={css.sectionHeader}>
                <span className={css.sectionTitle}>Price range</span>
              </div>
              <FilterComponent
                key="panel-price"
                id="SearchFiltersPanel.price"
                config={priceConfig}
                {...filterComponentProps}
                initialIsOpen={true}
              />
            </div>
          )}

          {/* Capacity section */}
          {seatsConfig && (
            <div className={css.section}>
              <div className={css.sectionHeader}>
                <span className={css.sectionTitle}>Capacity</span>
              </div>
              <FilterComponent
                key="panel-seats"
                id="SearchFiltersPanel.seats"
                config={seatsConfig}
                {...filterComponentProps}
              />
            </div>
          )}

          {/* Per-type category chip sections */}
          {SECTIONS.map(section => {
            const isTypeSelected = selectedTypes.includes(section.listingType);

            return (
              <div key={section.listingType} className={css.section}>
                <div className={css.sectionHeader}>
                  <span className={css.sectionTitle}>{section.label}</span>
                </div>
                <div className={css.chipGroup}>
                  <button
                    type="button"
                    className={classNames(css.panelChip, { [css.panelChipActive]: isTypeSelected })}
                    onClick={() => toggleType(section.listingType)}
                  >
                    All {section.label}
                  </button>
                  {section.subcategories.map(sub => {
                    const isActive = isChipActive(sub);
                    return (
                      <button
                        key={sub.name}
                        type="button"
                        className={classNames(css.panelChip, { [css.panelChipActive]: isActive })}
                        onClick={() => handleChipClick(sub)}
                      >
                        {sub.name}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}

          {/* Sort by — compact inline row, last section before footer */}
          {isSortActive && sortOptions?.length > 0 && (
            <div className={css.sortSection}>
              <span className={css.sortLabel}>Sort by</span>
              <div className={css.sortChips}>
                {sortOptions.map(option => {
                  const label = option.labelTranslationKey
                    ? intl.formatMessage({ id: option.labelTranslationKey })
                    : option.label;
                  const isSelected = currentSort === option.key;
                  return (
                    <button
                      key={option.key}
                      type="button"
                      disabled={option.disabled}
                      className={classNames(css.sortChip, {
                        [css.sortChipActive]: isSelected,
                      })}
                      onClick={() => {
                        if (!isSelected && !option.disabled) {
                          onSortSelect(sortQueryParamName, option.key);
                        }
                      }}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* Sticky footer */}
        <div className={css.footer}>
          <button
            type="button"
            className={css.clearBtn}
            onClick={handleClearAll}
          >
            Clear all
          </button>
          <button
            type="button"
            className={css.showResultsBtn}
            onClick={onClose}
            disabled={searchInProgress}
          >
            {resultsLabel}
          </button>
        </div>
      </div>
    </>
  );
};

export default SearchFiltersPanel;
